import type { AgentVersion } from '../types';

const PROXY_ORIGIN = 'https://fp.coinbase.com';

// Separate file to make testing easier
export async function dynamicImportAgent(
  apiKey: string,
  agentVersion: AgentVersion = 'v3',
): Promise<FingerprintAgent> {
  // Create a dynamic import function that won't be analyzed by Webpack
  const importFn = new Function('url', 'return import(url)');

  if (agentVersion === 'v4') {
    const Fingerprint = await importFn(`${PROXY_ORIGIN}/web/v4/${apiKey}`);
    // `start()` is synchronous in v4. `withoutDefault` keeps all traffic on our first-party
    // proxy instead of falling back to Fingerprint's default (non-allowlisted) endpoints.
    return Fingerprint.start({
      apiKey,
      endpoints: Fingerprint.withoutDefault(PROXY_ORIGIN),
    });
  }

  const FingerprintJS = await importFn(`${PROXY_ORIGIN}/web/v3/${apiKey}`);
  return FingerprintJS.load({
    endpoint: PROXY_ORIGIN,
    scriptUrlPattern: `${PROXY_ORIGIN}/web/v<version>/<apiKey>/loader_v<loaderVersion>.js`,
  });
}
